module.exports = __webpack_public_path__ + "img/sec_phone3.911fbc35.png";